export const LOGIN_INITIAL_FORM_STATE = {
  email_or_username: '',
  password: '',
};

export const LOGIN_INITIAL_CODE_STATE = {
  type: '',
  count: 0,
  context: {},
};

export const NOTIFICATION_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
} as const;

// Login Error Codes
export const INACTIVE_USER = 'inactive-user';
export const INTERNAL_SERVER_ERROR = 'internal-server-error';
export const INVALID_FORM = 'invalid-form';
export const NON_COMPLIANT_PASSWORD_EXCEPTION = 'NonCompliantPasswordException';
export const FORBIDDEN_REQUEST = 'forbidden-request';
export const FAILED_LOGIN_ATTEMPT = 'failed-login-attempt';
export const ACCOUNT_LOCKED_OUT = 'account-locked-out';
export const INCORRECT_EMAIL_PASSWORD = 'incorrect-email-or-password';
export const NUDGE_PASSWORD_CHANGE = 'nudge-password-change';
export const REQUIRE_PASSWORD_CHANGE = 'require-password-change';
export const ALLOWED_DOMAIN_LOGIN_ERROR = 'allowed-domain-login-error';
export const TPA_AUTHENTICATION_FAILURE = 'tpa-authentication-failure';
export const PASSWORD_RESET_INVALID_TOKEN = 'password-reset-invalid-token';

// Login Success Codes
export const PASSWORD_RESET_SUCCESS = 'password-reset-success';
export const FORGOT_PASSWORD_SUCCESS = 'forgot-password-success';
